import React from 'react';
import cx from 'classnames';

interface Props {
  className?: string;
  height?: number;
}

const Calendar: React.FC<Props> = ({ className, height = 18 }) => (
  <svg
    className={cx(className, `inline-block`)}
    width={height}
    height={height}
    viewBox="0 0 29 29"
  >
    <path
      className="fill-current"
      d="M28.275,2.63157895 L21.75,2.63157895 L21.75,0 L20.3,0 L20.3,2.63157895 L8.7,2.63157895 L8.7,0 L7.25,0 L7.25,2.63157895 L0,2.63157895 L0,20.3947368 C0,22.9376645 2.27269375,25 5.075,25 L23.925,25 C26.7273063,25 29,22.9376645 29,20.3947368 L29,2.63157895 L28.275,2.63157895 Z M7.25,3.94736842 L7.25,6.57894737 L8.7,6.57894737 L8.7,3.94736842 L20.3,3.94736842 L20.3,6.57894737 L21.75,6.57894737 L21.75,3.94736842 L27.55,3.94736842 L27.55,7.89473684 L1.45,7.89473684 L1.45,3.94736842 L7.25,3.94736842 Z M23.925,23.6842105 L5.075,23.6842105 C3.0727675,23.6842105 1.45,22.2116447 1.45,20.3947368 L1.45,9.21052632 L27.55,9.21052632 L27.55,20.3947368 C27.55,21.2672039 27.1676713,22.1037171 26.4879838,22.7204934 C25.8082963,23.3372697 24.8864587,23.6842105 23.925,23.6842105 Z"
    />
  </svg>
);

export default Calendar;
